// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl:'https://sy0tuy5l6b.execute-api.eu-central-1.amazonaws.com/dev',
  gatewayApiUrl:'https://sy0tuy5l6b.execute-api.eu-central-1.amazonaws.com/dev',
  userApiUrl:'https://sy0tuy5l6b.execute-api.eu-central-1.amazonaws.com/dev',
  parkAreaApiUrl:'https://cmkp3ovdaa.execute-api.eu-central-1.amazonaws.com/dev',
  companyApiUrl:'https://f49ghym8q1.execute-api.eu-central-1.amazonaws.com/dev',
  collectorApiUrl:'https://xadkq6b2ci.execute-api.eu-central-1.amazonaws.com/dev',
  personApiUrl:'https://17tudnf3e5.execute-api.eu-central-1.amazonaws.com/dev',
  s3Bucket:'https://parklab-service-bucket.s3.eu-central-1.amazonaws.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
